import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';

const BdRegumtoList = () => {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchEmog: '',
        searchDateCls: 'indt',
        searchIdno: '',
        searchGrdc: '',
        searchLoca: '',
        searchGubun: '',
        validationCheckList: ['searchLoca']
    });

    const searchParamsAdditional = {};

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['번호', '병원명', '등록번호', '내원날짜', '내원시간', '재검토날짜', '재검토시간', '구분', '내용', '상태']; //component화 
    const dataColumn = ['SEQ', 'EMOGDESC', 'ERROIDNO', 'ERROINDT', 'ERROINTM', 'ERROWRDT', 'ERROWRTM', 'ERROGUBN', 'ERRODESC', 'ERROFLAG'];
    const apiCall = '/ptmiapi/gumto/bdregumtolist_search.do';
    const apiCntCall = '/ptmiapi/gumto/bdregumtolist_cnt.do';
    const excelFileName = '재검토내역';
    const excelHead = [];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead,
        colWidth: ['5%', '11%', '8%', '8%', '5%', '8%', '5%', '10%', '25%', '8%'],
        wrapTF: true,
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: true,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="9%" />
                        <col width="23%" />
                        <col width="9%" />
                        <col width="20%" />
                        <col width="9%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                        </tr>
                        <tr>
                            <th>
                                <select
                                    id="searchDateCls"
                                    name="searchDateCls"
                                    value={searchParams.searchDateCls}
                                    onChange={handleInputChange}
                                >
                                    <option value="indt">내원일시</option>
                                    <option value="wrdt">전송일시</option>
                                </select>
                            </th>
                            <td>
                                <input
                                    type="date"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                />
                                &nbsp;~&nbsp;
                                <input
                                    type="date"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                />
                            </td>
                            <th>오류범위</th>
                            <td>
                                <select
                                    id="searchGubun"
                                    name="searchGubun"
                                    className='w-full'
                                    value={searchParams.searchGubun}
                                    onChange={handleInputChange}
                                >
                                    <option value="">전체</option>
                                    <option value="Y">재검토</option>
                                    <option value="N">재검토해소</option>
                                </select>
                            </td>
                            <th>등록번호</th>
                            <td>
                                <input
                                    type="text"
                                    id="searchIdno"
                                    name="searchIdno"
                                    value={searchParams.searchIdno}
                                    onChange={handleInputChange}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <p className='mb-0'> * 중앙서버로 전송되어진 환자정보 중 검토가 필요한 환자정보 입니다(오류내역이 아님). 각 개별 환자의 정보를 검토한 후 수정하여 재전송해주세요. </p>
            <p className='font-bold' style={{ color: "red" }}> * 매일 새벽 1시에 중앙서버에서 자동으로 재검토갱신을 하며, 유효하지 않은 재검토 내역은 자동 삭제합니다.
            </p>
        </Main>
    )
}

export default BdRegumtoList;